import { render, staticRenderFns } from "./TinkoffInstallment.vue?vue&type=template&id=16d4f8b6&"
import script from "./TinkoffInstallment.vue?vue&type=script&lang=js&"
export * from "./TinkoffInstallment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports